/**
 * 500 Server Error Page
 */

import { Link } from 'react-router';
import { Home, RefreshCw, AlertTriangle, Wrench } from 'lucide-react';

export default function ServerErrorPage() {
  const handleRefresh = () => {
    window.location.reload();
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-white to-red-50 flex items-center justify-center p-6">
      {/* Decorative background elements */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute -top-40 -right-40 w-80 h-80 bg-red-100 rounded-full opacity-50 blur-3xl" />
        <div className="absolute -bottom-40 -left-40 w-80 h-80 bg-orange-100 rounded-full opacity-50 blur-3xl" />
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-gradient-to-r from-red-50 to-orange-50 rounded-full opacity-30 blur-3xl" />
      </div>

      <div className="relative z-10 text-center max-w-lg">
        {/* 500 Icon */}
        <div className="mb-8 flex justify-center">
          <div className="relative">
            <div className="w-32 h-32 bg-gradient-to-br from-red-500 to-orange-600 rounded-3xl flex items-center justify-center shadow-2xl shadow-red-500/25 transform -rotate-3 hover:rotate-0 transition-transform duration-300">
              <AlertTriangle className="w-16 h-16 text-white" />
            </div>
            <div className="absolute -bottom-2 -left-2 w-12 h-12 bg-amber-400 rounded-xl flex items-center justify-center shadow-lg transform rotate-12 animate-pulse">
              <Wrench className="w-6 h-6 text-white" />
            </div>
          </div>
        </div>

        {/* Error Code */}
        <h1 className="text-8xl font-bold bg-gradient-to-r from-red-600 to-orange-600 bg-clip-text text-transparent mb-4">
          500
        </h1>

        {/* Title */}
        <h2 className="text-2xl font-semibold text-gray-900 mb-3">
          Server Error
        </h2>

        {/* Description */}
        <p className="text-gray-600 mb-8 leading-relaxed">
          Something went wrong on our end. Our team has been notified and is 
          working to fix the issue. Please try again in a few moments.
        </p>

        {/* Action Buttons */}
        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <button
            onClick={handleRefresh}
            className="inline-flex items-center justify-center gap-2 px-6 py-3 bg-gradient-to-r from-red-600 to-red-700 text-white font-medium rounded-xl hover:from-red-700 hover:to-red-800 transition-all shadow-lg shadow-red-500/25 hover:shadow-xl hover:shadow-red-500/30"
          >
            <RefreshCw className="w-4 h-4" />
            Try Again
          </button>
          <Link
            to="/dashboard"
            className="inline-flex items-center justify-center gap-2 px-6 py-3 bg-white text-gray-700 font-medium rounded-xl border border-gray-200 hover:bg-gray-50 hover:border-gray-300 transition-all shadow-sm"
          >
            <Home className="w-4 h-4" />
            Go to Dashboard
          </Link>
        </div>

        {/* Status indicator */}
        <div className="mt-10 inline-flex items-center gap-2 px-4 py-2 bg-amber-50 border border-amber-200 rounded-full">
          <span className="w-2 h-2 bg-amber-500 rounded-full animate-pulse" />
          <span className="text-sm text-amber-700 font-medium">
            Our team is investigating
          </span>
        </div>

        {/* Help text */}
        <p className="mt-6 text-sm text-gray-500">
          If the problem persists,{' '}
          <Link to="/help" className="text-indigo-600 hover:text-indigo-700 font-medium">
            contact support
          </Link>
        </p>
      </div>
    </div>
  );
}



